"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var DialogTitleTheme = function DialogTitleTheme(colors, breakpoints) {
  return {
    defaultProps: {
      variant: 'h4'
    },
    '&:first-of-type': {
      marginRight: '8px'
    },
    styleOverrides: {
      root: (0, _defineProperty2["default"])({
        padding: '20px 56px 20px 20px'
      }, breakpoints.up('sm'), {
        padding: '24px 32px 24px 32px'
      })
    }
  };
};

var _default = DialogTitleTheme;
exports["default"] = _default;